import { storyblokInit, apiPlugin, getStoryblokApi } from "@storyblok/react/rsc";
import Page from "@/components/utils/Page.component";
import Hero from "@/components/Hero.component";
import Projects from "@/components/Projects.component";
import TechStack from "@/components/TechStack.component";
import Text from "@/components/Text.component";

export const components = {
  page: Page,
  hero: Hero,
  tech_stack: TechStack,
  projects: Projects,
  text: Text,
};

// initialize the SDK

export const storyblokApi = storyblokInit({
  accessToken: process.env.NEXT_PUBLIC_STORYBLOK_TOKEN,
  use: [apiPlugin],
  components,
  bridge: process.env.NEXT_PUBLIC_DEV_MODE === "dev",
});

// re-export the getter
// this forces any file importing this to run the initialization above first
export { getStoryblokApi };